import React, { useState } from "react";
import TextsmsOutlinedIcon from "@mui/icons-material/TextsmsOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlined";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { hitUpdateBidProfessionalApi } from "../../../Redux/Professional/BidUpdateProfessionalSlice";
import { hitGetBidDetailsProfessionalApi } from "../../../Redux/Professional/BidDetailsProfessionalSlice";
import { hitSavePaymentRequestJobAPi } from "../../../Redux/Professional/SavePaymentRequestJobSlice";
import { hitGetContractProfessionalApi } from "../../../Redux/Professional/GetContractProfessionalSlice";
import { hitSetJobScheduleApi } from "../../../Redux/Professional/SetJobScheduleSlice";
import { showToast } from "../../../Helper/Toast";
import { formatDate } from "../../../Helper/CommonFunctions";
import { ApiBaseUrl, getContractProfessional } from "../../../Utils/Constants";
import "./AwardDetail.scss";
import BidJobDetails from "./BidJobDetails";

const AwardDetail = ({
  bidData,
  bidListData,
  setBidsData,
  setActiveTab,
  setAwardDetailShow,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showWithdrawModal, setShowWithdrawModal] = useState(false);
  const [showMarkCompleteModal, setShowMarkCompleteModal] = useState(false);
  const [showFeedback, setShowFeedback] = useState(false);
  const [showJobDetails, setShowJobDetails] = useState(false);

  const [openModal, setOpenModal] = useState(false);
  const [selectedRange, setSelectedRange] = useState(null);
  const [scheduleStart, setScheduleStart] = useState("");
  const [scheduleEnd, setScheduleEnd] = useState("");
  const [isScheduling, setIsScheduling] = useState(false);

  const handleSelect = (range) => {
    setSelectedRange(range);
    setOpenModal(false);
  };

  const openScheduleModal = () => {
    setScheduleStart(
      localBidData?.schdeuledDateStart
        ? localBidData.schdeuledDateStart.slice(0, 10)
        : ""
    );
    setScheduleEnd(
      localBidData?.scheduledDateEnd
        ? localBidData.scheduledDateEnd.slice(0, 10)
        : ""
    );
    setOpenModal(true);
  };

  const handleScheduleConfirm = () => {
    if (!scheduleStart || !scheduleEnd) {
      showToast("Please select both start and end dates", "error");
      return;
    }
    if (new Date(scheduleEnd) < new Date(scheduleStart)) {
      showToast("End date cannot be before start date", "error");
      return;
    }

    setIsScheduling(true);
    dispatch(
      hitSetJobScheduleApi({
        jobId: localBidData.jobId._id,
        schdeuledDateStart: scheduleStart,
        scheduledDateEnd: scheduleEnd,
      })
    )
      .then((res) => {
        if (res.payload && res.payload.status === true) {
          showToast("Job scheduled successfully", "success");
          setOpenModal(false);
          dispatch(
            hitGetBidDetailsProfessionalApi({ bidId: localBidData._id })
          );

          const updatedBidData = {
            ...localBidData,
            schdeuledDateStart: scheduleStart,
            scheduledDateEnd: scheduleEnd,
          };
          setLocalBidData(updatedBidData);
        }
      })
      .finally(() => {
        setIsScheduling(false);
      });
  };

  const handleJobCompleteConfirm = () => {
    dispatch(
      hitUpdateBidProfessionalApi({ bidId: localBidData._id, isCompleted: 1 })
    ).then((res) => {
      if (res.payload && res.payload.status === true) {
        showToast("Job Marked as Complete Successfully", "success");
        dispatch(hitGetBidDetailsProfessionalApi({ bidId: localBidData._id }));
        setShowMarkCompleteModal(false);

        const updatedBidData = { ...localBidData, status: 3 };
        setLocalBidData(updatedBidData);

        const updatedBidList = bidListData.map((bid) => {
          if (bid._id === bidData?._id) {
            return { ...bid, status: 3 };
          }
          return bid;
        });
        setBidsData(updatedBidList);
      }
    });
  };

  const handleViewContractClick = () => {
    //console.log("View Contract clicked");
    window.open(
      `${ApiBaseUrl}${getContractProfessional}/?jobId=` +
        localBidData.jobId._id +
        "&authorization=" +
        localStorage.getItem("professionalToken"),
      "_blank"
    );
  };
  const handleJobCompleteCancel = () => {
    setShowMarkCompleteModal(false);
    //console.log("Job Complete cancelled");
  };

  const handleConfirm = () => {
    dispatch(
      hitUpdateBidProfessionalApi({ bidId: localBidData._id, isWithdrawBid: 1 })
    ).then((res) => {
      if (res.payload && res.payload.status === true) {
        showToast("Bid Award Withdrawn Successfully", "success");
        dispatch(hitGetBidDetailsProfessionalApi({ bidId: localBidData._id }));
        setShowWithdrawModal(false);
        setAwardDetailShow(false);
        setActiveTab("bid-placed");

        const updatedBidData = { ...localBidData, isWithdraw: 1, status: 1 };
        setLocalBidData(updatedBidData);

        const updatedBidList = bidListData.map((bid) => {
          if (bid._id === bidData?._id) {
            return { ...bid, isWithdraw: 1, status: 1 };
          }
          return bid;
        });
        setBidsData(updatedBidList);
      }
    });

    //console.log("Withdraw confirmed");
  };

  const handleCancel = () => {
    setShowWithdrawModal(false);
    //console.log("Withdraw cancelled");
  };

  const [localBidData, setLocalBidData] = useState(bidData);

  const [feedbackData, setFeedbackData] = useState({
    accuracy: 71,
    engagement: 90,
    timelyPayment: 62,
  });

  const handleMarkCompleteModal = () => {
    setShowMarkCompleteModal(true);
  };

  const handleSignatureClick = () => {
    //console.log("Collect Signature clicked");
    dispatch(
      hitUpdateBidProfessionalApi({
        bidId: localBidData._id,
        isSignatureSend: 1,
      })
    ).then((res) => {
      if (res.payload && res.payload.status === true) {
        setShowSuccessModal(true);
        setTimeout(() => {
          setShowSuccessModal(false);
          dispatch(
            hitGetBidDetailsProfessionalApi({ bidId: localBidData._id })
          );
        }, 1500);

        const updatedBidData = { ...localBidData, isContractApproved: 1 };
        setLocalBidData(updatedBidData);

        const updatedBidList = bidListData.map((bid) => {
          if (bid._id === bidData?._id) {
            return { ...bid, isContractApproved: 1 };
          }
          return bid;
        });
        setBidsData(updatedBidList);
      }
    });
  };

  useEffect(() => {
    setLocalBidData(bidData);
  }, [bidData]);

  const calculateOverallRating = () => {
    const avg = Math.round(
      (feedbackData.accuracy +
        feedbackData.engagement +
        feedbackData.timelyPayment) /
        3
    );
    return avg;
  };

  const getRatingLabel = (rating) => {
    if (rating >= 80) return "Excellent";
    if (rating >= 60) return "Good";
    if (rating >= 40) return "Average";
    return "Poor";
  };

  const handleSliderChange = (field, value) => {
    setFeedbackData((prev) => ({
      ...prev,
      [field]: parseInt(value),
    }));
  };

  const handleSubmitFeedback = () => {
    //console.log("Feedback submitted:", feedbackData);
    feedbackData.bidId = localBidData._id;
    feedbackData.clientRating = 1;
    dispatch(hitUpdateBidProfessionalApi(feedbackData)).then((res) => {
      if (res.payload && res.payload.status === true) {
        showToast("Feedback submitted successfully", "success");
        setShowFeedback(false);
        dispatch(hitGetBidDetailsProfessionalApi({ bidId: localBidData._id }));

        const updatedBidData = { ...localBidData, isClientRatingDone: 1 };
        setLocalBidData(updatedBidData);

        const updatedBidList = bidListData.map((bid) => {
          if (bid._id === bidData?._id) {
            return { ...bid, isClientRatingDone: 1 };
          }
          return bid;
        });
        setBidsData(updatedBidList);
      }
    });
  };

  const cardData = {
    pending: {
      status: "Pending",
      statusClass: "pending",
      progress: [
        { step: 1, label: "In Progress", active: true },
        { step: 2, label: "Approved", active: false },
        { step: 3, label: "Completed", active: false },
      ],
      buttons: [
        { label: "Message", icon: <TextsmsOutlinedIcon />, variant: "outline" },
        { label: "Collect Signature", icon: "✍️", variant: "primary" },
      ],
      menuItems: [
        { label: "View Project", icon: <VisibilityOutlinedIcon /> },
        { label: "View Bid", icon: "📄" },
        // { label: "Preview PDF Quote", icon: <VisibilityOutlinedIcon /> },
      ],
    },
    cancelled: {
      status: "Cancelled",
      statusClass: "cancelled",
      alert: "Contract is Cancelled",
      buttons: [],
      menuItems: [
        { label: "View Project", icon: <VisibilityOutlinedIcon /> },
        { label: "Payment Collected Externally", icon: "💳" },
      ],
    },
    inProgress: {
      status: "In Progress",
      statusClass: "in-progress",
      progress: [
        { step: 1, label: "In Progress", completed: true },
        { step: 2, label: "Approved", active: true },
        { step: 3, label: "Completed", completed: false },
      ],
      buttons: [
        { label: "Message", icon: <TextsmsOutlinedIcon />, variant: "outline" },
        {
          label: "View Contract",
          icon: <VisibilityOutlinedIcon />,
          variant: "primary",
        },
      ],
      menuItems: [
        { label: "View Project", icon: <VisibilityOutlinedIcon /> },
        { label: "View Bid", icon: "📄" },
        { label: "Payments", icon: "💳" },
        { label: "Mark Complete", icon: <CheckCircleOutlinedIcon /> },
        {
          label: "Schedule Job",
          icon: <CalendarTodayOutlinedIcon />,
        },
      ],
      footer: "Withdraw Awarding",
    },
    completed: {
      status: "Completed",
      statusClass: "completed",
      progress: [
        { step: 1, label: "In Progress", completed: true },
        { step: 2, label: "Approved", completed: true },
        { step: 3, label: "Completed", completed: true },
      ],
      buttons: [
        { label: "Message", icon: <TextsmsOutlinedIcon />, variant: "outline" },
        { label: "View Contract", icon: "✓", variant: "primary" },
      ],
      menuItems: [
        { label: "View Project", icon: <VisibilityOutlinedIcon /> },
        { label: "Payments", icon: "💳" },
      ],
      footer: "Rate Client",
    },
    completedRatingDone: {
      status: "Completed",
      statusClass: "completed",
      progress: [
        { step: 1, label: "In Progress", completed: true },
        { step: 2, label: "Approved", completed: true },
        { step: 3, label: "Completed", completed: true },
      ],
      buttons: [
        { label: "Message", icon: <TextsmsOutlinedIcon />, variant: "outline" },
        { label: "View Contract", icon: "✓", variant: "primary" },
      ],
      menuItems: [
        { label: "View Project", icon: <VisibilityOutlinedIcon /> },
        { label: "Payments", icon: "💳" },
      ],
      footer: "Rating Already Done",
    },
  };

  let currentData = {};

  if (localBidData.status == 2 && localBidData.isContractApproved == 0) {
    currentData = cardData["pending"];
  } else if (
    localBidData.status == 2 &&
    (localBidData.isContractApproved == 3 ||
      localBidData.isContractApproved == 4)
  ) {
    currentData = cardData["cancelled"];
  } else if (
    localBidData.status == 2 &&
    (localBidData.isContractApproved == 1 ||
      localBidData.isContractApproved == 2)
  ) {
    currentData = cardData["inProgress"];
  } else if (localBidData.status == 3 && localBidData.isClientRatingDone == 1) {
    currentData = cardData["completedRatingDone"];
  } else if (localBidData.status == 3) {
    currentData = cardData["completed"];
  }

  const overallRating = calculateOverallRating();

  return (
    <div className="profile-cardss">
      {/* Profile Section */}
      <div className="profile-header">
        <div className="profile-image">
          <img src="https://i.pravatar.cc/150?img=12" alt="Ryan Smith" />
        </div>
        <h2 className="profile-name">
          {localBidData?.userId?.firstName} {localBidData?.userId?.lastName}
        </h2>
        <p className="job-id">Job {localBidData?.jobId?.jobId}</p>
        <span className={`status-badge ${currentData.statusClass}`}>
          {currentData.status}
        </span>
      </div>

      {/* Alert Message */}
      {currentData.alert && (
        <div className="alert_center">
          <div className="alert-message">{currentData.alert}</div>
        </div>
      )}

      {/* Progress Steps */}
      {currentData.progress && (
        <div className="progress-container">
          {currentData.progress.map((item, index) => (
            <div key={index} className="progress-item">
              <div
                className={`progress-circle ${item.active ? "active" : ""} ${
                  item.completed ? "completed" : ""
                }`}
              >
                {item.completed ? "✓" : item.step}
              </div>
              <span className="progress-label">{item.label}</span>
            </div>
          ))}
        </div>
      )}

      {/* Action Buttons */}
      {currentData.buttons.length > 0 && (
        <div className="action-buttons">
          {currentData.buttons.map((btn, index) => (
            <button
              key={index}
              className={`btn btn-${btn.variant}`}
              onClick={() =>
                btn.label === "Collect Signature"
                  ? handleSignatureClick()
                  : btn.label === "View Contract"
                  ? handleViewContractClick()
                  : btn.label === "Message"
                  ? navigate("/professional/messages", {
                      state: { chatId: localBidData.chatId },
                    })
                  : null
              }
            >
              <span className="btn-icon">{btn.icon}</span>
              {btn.label}
            </button>
          ))}
        </div>
      )}

      {/* Menu Items */}

      <div className="menu-items">
        {currentData.menuItems.map((item, index) => (
          <button
            key={index}
            className="menu-item"
            onClick={() =>
              item.label === "Mark Complete"
                ? handleMarkCompleteModal()
                : item.label === "View Project"
                ? setShowJobDetails(true)
                : item.label === "Payments"
                ? navigate("/professional/payments/" + localBidData.jobId._id)
                : item.label === "View Bid"
                ? navigate(
                    "/professional/job-details/" + localBidData.jobId._id
                  )
                : item.label === "Schedule Job"
                ? openScheduleModal()
                : null
            }
          >
            <span className="menu-icon">{index + 1}</span>
            <span className="menu-label">{item.label}</span>
            {/* <span className="menu-arrow">
              {item.label === "Payments" ? (
                <div
                  className={`toggle-slider ${
                    paymentCollected ? "active" : ""
                  }`}
                  onClick={handlePaymentToggle}
                >
                  <div className="toggle-slider-track">
                    <div className="toggle-slider-thumb"></div>
                  </div>
                </div>
              ) : (
                "›"
              )}
            </span> */}
          </button>
        ))}
      </div>

      {/* Extra Button */}
      {currentData.extraButton && (
        <button className="extra-button">
          <span className="btn-icon">{currentData.extraButton.icon}</span>
          {currentData.extraButton.label}
        </button>
      )}

      {/* Scheduled Dates */}
      {(() => {
        const scheduleStart =
          localBidData?.jobId?.schdeuledDateStart ||
          localBidData?.jobId?.scheduledDateStart;
        const scheduleEnd =
          localBidData?.jobId?.scheduledDateEnd ||
          localBidData?.jobId?.scheduledDateEnd;
        const formattedStart = formatDate(scheduleStart);
        const formattedEnd = formatDate(scheduleEnd);
        if (!formattedStart && !formattedEnd) return null;

        return (
          <div className="scheduled-dates">
            <div className="scheduled-dates-header">
              <CalendarTodayOutlinedIcon sx={{ fontSize: 18 }} />
              <span>Scheduled</span>
            </div>
            <div className="scheduled-dates-body">
              <div className="scheduled-date-item">
                <span className="scheduled-date-label">Start</span>
                <span className="scheduled-date-value">
                  {formattedStart || "—"}
                </span>
              </div>
              <div className="scheduled-date-item">
                <span className="scheduled-date-label">End</span>
                <span className="scheduled-date-value">
                  {formattedEnd || "—"}
                </span>
              </div>
            </div>
          </div>
        );
      })()}

      {/* Schedule Info */}
      {currentData.schedule && (
        <p className="schedule-info">{currentData.schedule}</p>
      )}

      {/* Footer */}
      {currentData.footer && (
        <>
          {currentData.footer === "Withdraw Awarding" ? (
            <p
              className="footer-text"
              style={{ cursor: "pointer" }}
              onClick={() => setShowWithdrawModal(true)}
            >
              {currentData.footer}
            </p>
          ) : currentData.footer === "Rate Client" ? (
            <>
              <p
                className="footer-text"
                style={{ cursor: "pointer" }}
                onClick={() => setShowFeedback(true)}
              >
                {currentData.footer}
              </p>
            </>
          ) : (
            <>
              <p className="footer-text">{currentData.footer}</p>
            </>
          )}
        </>
      )}

      {showJobDetails && <BidJobDetails jobData={localBidData} />}

      {/* Feedback Section */}
      {showFeedback && (
        <div className="feedback-section">
          <div className="feedback-header">
            <h3 className="feedback-title">Leave Feedback to Client</h3>
            <p className="feedback-subtitle">
              Your honest feedback helps maintain quality standards
            </p>
          </div>

          {/* Overall Rating Display */}
          <div className="overall-rating">
            <div className="rating-info">
              <span className="rating-label">Overall Rating</span>
              <span className="rating-status">
                {getRatingLabel(overallRating)}
              </span>
            </div>
            <div className="rating-score">
              <span className="score-value">{overallRating}</span>
              <span className="score-max">/100</span>
            </div>
          </div>

          {/* Project Clarity */}
          <div className="feedback-item">
            <div className="feedback-item-header">
              <span className="feedback-item-title">Project Clarity</span>
              <span className="feedback-item-value">
                {feedbackData.accuracy}
              </span>
            </div>
            <p className="feedback-item-desc">
              How accurate the project was compared to the actual job
            </p>
            <div className="slider-container">
              <input
                type="range"
                min="0"
                max="100"
                value={feedbackData.accuracy}
                onChange={(e) => handleSliderChange("accuracy", e.target.value)}
                className="feedback-slider"
              />
              <div className="slider-labels">
                <span>0</span>
                <span>50</span>
                <span>/100</span>
              </div>
            </div>
          </div>

          {/* Engagement */}
          <div className="feedback-item">
            <div className="feedback-item-header">
              <span className="feedback-item-title">Engagement</span>
              <span className="feedback-item-value">
                {feedbackData.engagement}
              </span>
            </div>
            <p className="feedback-item-desc">
              How responsive, respectful, and clear the client was during the
              process
            </p>
            <div className="slider-container">
              <input
                type="range"
                min="0"
                max="100"
                value={feedbackData.engagement}
                onChange={(e) =>
                  handleSliderChange("engagement", e.target.value)
                }
                className="feedback-slider"
              />
              <div className="slider-labels">
                <span>0</span>
                <span>50</span>
                <span>/100</span>
              </div>
            </div>
          </div>

          {/* Timely Payment */}
          <div className="feedback-item">
            <div className="feedback-item-header">
              <span className="feedback-item-title">Timely Payment</span>
              <span className="feedback-item-value">
                {feedbackData.timelyPayment}
              </span>
            </div>
            <p className="feedback-item-desc">
              Reflects how promptly the client fulfilled payment after the work
              was completed
            </p>
            <div className="slider-container">
              <input
                type="range"
                min="0"
                max="100"
                value={feedbackData.timelyPayment}
                onChange={(e) =>
                  handleSliderChange("timelyPayment", e.target.value)
                }
                className="feedback-slider"
              />
              <div className="slider-labels">
                <span>0</span>
                <span>50</span>
                <span>/100</span>
              </div>
            </div>
          </div>

          {/* Submit Button */}
          <button
            className="submit-feedback-btn"
            onClick={handleSubmitFeedback}
          >
            Submit Feedback
          </button>
        </div>
      )}

      {/* Success Modal */}
      {showSuccessModal && (
        <div className="modal-overlay">
          <div className="success-modal">
            <div className="success-icon">✅</div>
            <p className="success-message">Signature collected Successfully!</p>
          </div>
        </div>
      )}

      {/* Withdraw Awarding Modal */}
      {showWithdrawModal && (
        <div className="modal-overlay">
          <div className="withdraw-modal">
            <div className="withdraw-icon">⚠️</div>
            <p className="withdraw-message">
              Withdraw Awarding?
              <br />
              The customer will receive a notification of your withdrawal.
            </p>
            <div className="modal-actions">
              <button className="confirm-btn" onClick={handleConfirm}>
                Confirm
              </button>
              <button className="cancel-btn" onClick={handleCancel}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Schedule Job Modal */}
      {openModal && (
        <div className="modal-overlay">
          <div className="schedule-modal">
            <div className="schedule-icon">
              <CalendarTodayOutlinedIcon />
            </div>
            <h3 className="schedule-title">Schedule Job</h3>
            <p className="schedule-subtitle">
              Set the start and end dates for this job.
            </p>

            <div className="schedule-fields">
              <label className="schedule-field">
                <span>Start Date</span>
                <input
                  type="date"
                  value={scheduleStart}
                  onChange={(e) => setScheduleStart(e.target.value)}
                />
              </label>
              <label className="schedule-field">
                <span>End Date</span>
                <input
                  type="date"
                  min={scheduleStart || undefined}
                  value={scheduleEnd}
                  onChange={(e) => setScheduleEnd(e.target.value)}
                />
              </label>
            </div>

            <div className="modal-actions">
              <button
                className="confirm-btn"
                onClick={handleScheduleConfirm}
                disabled={isScheduling}
              >
                {isScheduling ? "Saving..." : "Confirm"}
              </button>
              <button
                className="cancel-btn"
                onClick={() => setOpenModal(false)}
                disabled={isScheduling}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Mark Complete Modal */}
      {showMarkCompleteModal && (
        <div className="modal-overlay">
          <div className="withdraw-modal">
            <div className="success-icon">✅</div>
            <p className="withdraw-message">
              Job Complete?
              <br />
              The customer will receive a notification about the job
              completetion.
            </p>
            <div className="modal-actions">
              <button
                className="confirm-btn"
                onClick={handleJobCompleteConfirm}
              >
                Confirm
              </button>
              <button className="cancel-btn" onClick={handleJobCompleteCancel}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AwardDetail;
